var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-6"},[_vm._l((_vm.fixedWidths),function(value,prop){return _c('div',{key:prop},[_c('CanvasSectionRow',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var blockClasses = ref.blockClasses;
return [_c('div',{class:blockClasses,style:({
          width: value.includes('vw') ? '100%' : value,
          maxWidth: '100%'
        })})]}}],null,true)}),_c('CanvasBlockLabel',{attrs:{"label":("w-" + prop),"value":value}})],1)}),_vm._l((_vm.percentWidths),function(value,prop){return _c('div',{key:prop,staticClass:"mb-6"},[_c('CanvasSectionRow',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var blockClasses = ref.blockClasses;
return [_c('div',{class:blockClasses,style:({
          width: value,
          maxWidth: '100%',
        })})]}}],null,true)}),_c('CanvasBlockLabel',{attrs:{"label":("w-" + prop),"value":value}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }